const AudienceCtaModal = () => {
  const openers = document.querySelectorAll("[data-audience-cta-modal-open]");
  const modals = [...document.querySelectorAll("[data-audience-cta-modal]")];

  if (!openers.length) return;

  modals.forEach((modal) => document.body.appendChild(modal));

  let activeModal = null;
  let activeOpener = null;

  const getFocusableElements = (modal) => [...modal.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )].filter((element) => !element.hidden && element.offsetParent !== null);

  const closeModal = () => {
    if (!activeModal) return;

    const opener = activeOpener;
    activeModal.classList.remove("is-open");
    activeModal.hidden = true;
    document.body.classList.remove("audience-cta-modal-open");
    activeModal = null;
    activeOpener = null;
    opener?.focus();
  };

  const openModal = (opener) => {
    const modal = document.getElementById(opener.dataset.audienceCtaModalOpen);

    if (!modal) return;

    activeModal = modal;
    activeOpener = opener;
    modal.hidden = false;
    modal.classList.add("is-open");
    document.body.classList.add("audience-cta-modal-open");

    const focusableElements = getFocusableElements(modal);
    (modal.querySelector("[data-audience-cta-modal-close]") || focusableElements[0])?.focus();
  };

  openers.forEach((opener) => {
    opener.addEventListener("click", () => openModal(opener));
  });

  modals.forEach((modal) => {
    modal.querySelector("[data-audience-cta-modal-close]")?.addEventListener("click", closeModal);
    modal.addEventListener("click", (event) => {
      if (event.target === modal) closeModal();
    });
  });

  document.addEventListener("keydown", (event) => {
    if (!activeModal) return;

    if ("Escape" === event.key) {
      closeModal();
      return;
    }

    if ("Tab" !== event.key) return;

    const focusableElements = getFocusableElements(activeModal);
    if (!focusableElements.length) {
      event.preventDefault();
      return;
    }

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  });
};

export default AudienceCtaModal;
